import styled, { keyframes } from 'styled-components';
import { Card, Flex } from 'core/components';

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const slideDown = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(100%);
  }
`;

export const COPILOT_CONFIG = {
  POSITION: {
    BOTTOM: 24,
    RIGHT: 24
  },
  DIMENSIONS: {
    MIN_WIDTH: 400,
    MIN_HEIGHT: 300,
    DEFAULT_WIDTH: 650,
    DEFAULT_HEIGHT: 650
  },
  RESIZE: {
    HANDLE_SIZE: 4,
    CORNER_SIZE: 12
  },
  ANIMATION: {
    DURATION: '0.3s'
  },
  SCROLL_DELAY: 200
};

export const AnimatedCard = styled(Card)`
  position: fixed;
  bottom: ${COPILOT_CONFIG.POSITION.BOTTOM}px;
  right: ${COPILOT_CONFIG.POSITION.RIGHT}px;
  background: white;
  border-radius: 12px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  opacity: 0;
  transform: translateY(20px) scale(0.95);
  transition:
    opacity ${COPILOT_CONFIG.ANIMATION.DURATION} ease,
    transform ${COPILOT_CONFIG.ANIMATION.DURATION} ease;

  &.visible {
    opacity: 1;
    transform: translateY(0) scale(1);
  }

  &.hidden {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
    pointer-events: none;
  }
`;

export const ResizeHandle = styled.div`
  position: absolute;

  &.resizer {
    border-radius: 2px;
    z-index: 1000;
  }

  &.resize-top {
    top: -4px;
    left: 8px;
    right: 8px;
    height: ${COPILOT_CONFIG.RESIZE.HANDLE_SIZE}px;
    cursor: n-resize;
  }

  &.resize-left {
    top: 8px;
    bottom: 8px;
    left: -4px;
    width: ${COPILOT_CONFIG.RESIZE.HANDLE_SIZE}px;
    cursor: w-resize;
  }

  &.resize-top-left {
    top: -4px;
    left: -4px;
    width: ${COPILOT_CONFIG.RESIZE.CORNER_SIZE}px;
    height: ${COPILOT_CONFIG.RESIZE.CORNER_SIZE}px;
    cursor: nw-resize;
  }

  &:hover {
    background-color: rgba(0, 123, 255, 0.2);
  }
`;

export const ScrollToBottomButton = styled.div`
  position: absolute;
  bottom: 134px;
  right: 16px;
  z-index: 10;
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  animation: ${({ $isVisible }) => ($isVisible ? slideUp : slideDown)} 200ms cubic-bezier(0.33, 1, 0.68, 1);
  pointer-events: ${({ $isVisible }) => ($isVisible ? 'auto' : 'none')};

  .bp4-button {
    border-radius: 100% !important;
    width: 40px;
    height: 40px;

    .bp4-icon {
      margin: 0;
    }
  }
`;

export const ScrollContainer = styled(Flex)`
  position: relative;
`;
